import { IPerson } from '../../../services/person.service';
class EmployeeListController {

    private salaryScales: IPerson[];
    
    constructor() {
        "ngInject";
    }
}

export const salaryScaleListComponent = {
    bindings: {
        salaryScales : "<"
    },
    controller : EmployeeListController,
    template : require("./salaryScale.list.html")
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/salaryScales/salaryScale.list.component.ts